import NDASuccess from '../components/ProjectWizard/NDASuccess';

const NDASuccessPage = () => {
    return <NDASuccess />;
};

export default NDASuccessPage;
